import { HoldEventUnitView } from '@mark43/cad-api';

export function unitCallSignSortComparator(a: HoldEventUnitView, b: HoldEventUnitView) {
    return a.callSign.label.localeCompare(b.callSign.label);
}
